export var RewardActionTypeEnum;
(function (RewardActionTypeEnum) {
    RewardActionTypeEnum["BONUS"] = "BONUS";
})(RewardActionTypeEnum || (RewardActionTypeEnum = {}));
//# sourceMappingURL=reward-action-type.enum.js.map